import { yieldToMainThread } from '@theme/utilities';
import { Component } from '@theme/component';
class FlyToCart extends Component {
  // Preserve properties assigned before this lazy element is upgraded.
  #observer;
  connectedCallback() {
    super.connectedCallback();
    if (!(this.source instanceof Element) || !(this.destination instanceof Element) ||
        typeof IntersectionObserver !== 'function' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.remove();
      return;
    }
    let sourceRect;
    let destinationRect;
    this.#observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === this.source) sourceRect = entry.boundingClientRect;
        if (entry.target === this.destination) destinationRect = entry.boundingClientRect;
      }
      if (sourceRect && destinationRect) {
        this.#observer.disconnect();
        this.#animate(sourceRect, destinationRect);
      }
    });
    this.#observer.observe(this.source);
    this.#observer.observe(this.destination);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }
  async #animate(sourceRect, destinationRect) {
    const startPoint = { x: sourceRect.left + sourceRect.width / 2, y: sourceRect.top + sourceRect.height / 2 };
    const endPoint = { x: destinationRect.left + destinationRect.width / 2, y: destinationRect.top + destinationRect.height / 2 };
    if (this.useSourceSize) {
      this.style.setProperty('--width', `${sourceRect.width}px`);
      this.style.setProperty('--height', `${sourceRect.height}px`);
    }
    this.style.setProperty('--start-x', `${startPoint.x}px`);
    this.style.setProperty('--start-y', `${startPoint.y}px`);
    this.style.setProperty('--travel-x', `${endPoint.x - startPoint.x}px`);
    this.style.setProperty('--travel-y', `${endPoint.y - startPoint.y}px`);
    await yieldToMainThread();
    await Promise.allSettled(this.getAnimations().map(animation => animation.finished));
    this.remove();
  }
}
if (!customElements.get('fly-to-cart')) customElements.define('fly-to-cart', FlyToCart);
